import { useState } from "react";
import { toast } from "react-toastify";
import { NxtbnDrawer } from "..";
import enumChoice, { getEnumItem } from "../../enum";
import useApi from "../../api";
import { InputField } from "../common";
import SelectStyled from "../Select";
import moment from "moment";


function PromoCodeForm({ edit, isOpen, onClose, fetchPromoCodes }: { edit:any; isOpen: boolean; onClose: () => void; fetchPromoCodes:()=>void }) {
  const api = useApi()

  const [promoData, setPromoData] = useState( edit ? edit : {
    code: "", // Changed to snake case
    description: "",
    code_type: "PERCENTAGE", // default value in snake case
    value: "",
    expiration_date: new Date(),
    min_purchase_amount: "",
    min_purchase_period: "",
    redemption_limit: "",
    new_customers_only: false,
    is_active: false,
    usage_limit_per_customer: 1,
  });
  const [errorData, setErrorData] = useState<any>()

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPromoData((prev:any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSelectChange = (selectedOption: any, field: string) => {
    setPromoData((prev:any) => ({
      ...prev,
      [field]: selectedOption.value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!edit){
    api.createPromocodes(promoData).then((response:any)=>{
      toast.success("Promo code created successfully!");
      fetchPromoCodes()
      onClose();
    }, (error:any)=> setErrorData(error.response.data))
  }else {
    api.updatePromocode(edit.id, promoData).then((response:any)=>{
      toast.success("Promo code successfully updated.")
      fetchPromoCodes()
      onClose()
    }, (error:any)=>setErrorData(error.response.data))
  }
    
  };

  return (
    <NxtbnDrawer title="Create Promo Code" isOpen={isOpen} onClose={onClose}>
      <form onSubmit={handleSubmit} className="p-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
          <div>
            <label htmlFor="promo_code" className="block text-sm font-medium text-gray-700">
              Promo Code
            </label>
            <InputField
              type="text"
              id="promo_code"
              name="code"
              value={promoData.code}
              onChange={handleChange}
              className="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500"
              placeholder="Enter promo code"
              errorData={errorData}
            />
          </div>

          <div>
            <label htmlFor="description" className="block text-sm font-medium text-gray-700">
              Description
            </label>
            <InputField
              type="text"
              id="description"
              name="description"
              value={promoData.description}
              onChange={handleChange}
              className="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500"
              placeholder="Enter description"
              errorData={errorData}
            />
          </div>

          <div>
            <label htmlFor="code_type" className="block text-sm font-medium text-gray-700">
              Code Type
            </label>
            <SelectStyled
              name="code_type"
              defaultValue={getEnumItem(enumChoice.promoCodeType, promoData.code_type)}
              options={enumChoice.promoCodeType}
              onChange={(option) => handleSelectChange(option, "code_type")}
              className="mt-1 block w-full"
              errorData={errorData}
            />
          </div>

          <div>
            <label htmlFor="value" className="block text-sm font-medium text-gray-700">
              Value
            </label>
            <InputField
              type="number"
              id="value"
              name="value"
              value={promoData.value}
              onChange={handleChange}
              className="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500"
              placeholder="Enter value (e.g., 10 for 10%)"
              errorData={errorData}
            />
          </div>

          <div>
            <label htmlFor="expiration_date" className="block text-sm font-medium text-gray-700">
              Expiration Date
            </label>
            <InputField
              type="datetime-local"
              id="expiration_date"
              name="expiration_date"
              value={moment(promoData.expiration_date).format("YYYY-MM-DDTHH:mm")}
              onChange={handleChange}
              className="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500"
              errorData={errorData}
            />
          </div>

          <div>
            <label htmlFor="min_purchase_amount" className="block text-sm font-medium text-gray-700">
              Minimum Purchase Amount
            </label>
            <InputField
              type="number"
              id="min_purchase_amount"
              name="min_purchase_amount"
              value={promoData.min_purchase_amount}
              onChange={handleChange}
              className="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500"
              placeholder="Enter minimum purchase amount"
              errorData={errorData}
            />
          </div>

          <div>
            <label htmlFor="min_purchase_period" className="block text-sm font-medium text-gray-700">
              Minimum Purchase Period (in days)
            </label>
            <InputField
              type="number"
              id="min_purchase_period"
              name="min_purchase_period"
              value={promoData.min_purchase_period.split(' ')[0]}
              onChange={(e:any)=>setPromoData((prev:any)=>({...prev, [e.target.name]: `${e.target.value} 00:00:00`}))}
              className="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500"
              placeholder="Enter minimum purchase period"
              errorData={errorData}
            />
          </div>

          <div>
            <label htmlFor="redemption_limit" className="block text-sm font-medium text-gray-700">
              Redemption Limit
            </label>
            <InputField
              type="number"
              id="redemption_limit"
              name="redemption_limit"
              value={promoData.redemption_limit}
              onChange={handleChange}
              className="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500"
              placeholder="Enter redemption limit"
              errorData={errorData}
            />
          </div>

          <div>
            <label htmlFor="usage_limit_per_customer" className="block text-sm font-medium text-gray-700">
              Usage Limit Per Customer
            </label>
            <InputField
              type="number"
              id="usage_limit_per_customer"
              name="usage_limit_per_customer"
              value={promoData.usage_limit_per_customer}
              onChange={handleChange}
              className="mt-1 p-2 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500"
              errorData={errorData}
            />
          </div>
          <div className="lg:hidden"></div>
          <div className="flex flex-col items-start">
          <div className="flex flex-row-reverse gap-2 items-center">
            <label className="block text-sm font-medium text-gray-700 text-nowrap">New Customers Only</label>
            <InputField
              type="checkbox"
              id="new_customers_only"
              name="new_customers_only"
              checked={promoData.new_customers_only}
              onChange={() =>
                setPromoData((prev:any) => ({
                  ...prev,
                  new_customers_only: !prev.new_customers_only,
                }))
              }
              className="mt-1"
              errorData={errorData}
            />
          </div>
          <div className="flex flex-row-reverse gap-2 items-center justify-start">
            <label className="block text-sm font-medium text-gray-700">Is active</label>
            <InputField
              type="checkbox"
              id="is_active"
              name="is_active"
              checked={promoData?.is_active}
              onChange={() =>
                setPromoData((prev:any) => ({
                  ...prev,
                  is_active: !prev.is_active,
                }))
              }
              className="mt-1"
              errorData={errorData}
            />
          </div>
          </div>
        </div>

        <div className="flex justify-end mt-4">
          <button
            type="button"
            onClick={onClose}
            className="mr-2 px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700"
          >
            Create
          </button>
        </div>
      </form>
    </NxtbnDrawer>
  );
}

export default PromoCodeForm;
